const ORGANIZATION = 'cYsQuLVKMFuBf9NKIgja';
const APPID = 'default';
const CHANNEL = 'yaduo_atat_h5';
const PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC1jEeVuNFIkYl0wPvjLfozB8QMAUCybPMnbZ1I2sRcQ1A6ZYMC7K3zy4eQtSY+dr2g/TfoBlG6neTshs6vUixQ7MLk+EXTLwHXjiHOu8gy+6dJpN0qdCoBGBY9qJD6J2t24cSkuOxYXSm5Mt7uFgbywYU+MBs8rXZpMhaAgyZyGQIDAQAB';

export function smFpInit() {
    window._smReadyFuncs = [];
    window.SMSdk = {
        onBoxDataReady: function(boxData) { // 非必填
            console.log('此时拿到的数据为boxData或者boxId', boxData);
        },
        ready: function(fn) {
            fn && window._smReadyFuncs.push(fn);
        },
    };

    // 1. 通用配置项
    window._smConf = {
        organization: ORGANIZATION, // 必填，组织标识，邮件中organization项
        appId: APPID, // 必填，应用标识，默认传值default，其他应用标识提前联系数美协助定义
        publicKey: PUBLIC_KEY, // 必填，私钥标识，邮件中publicKey项
        channel: CHANNEL, // 业务渠道标识，默认web，如有特殊需求可联系数美支持定义
        staticHost: 'static.portal101.cn', // 必填, 设置JS-SDK文件域名，建议填写static.portal101.cn
        protocol: 'https', // 如果使用https，则设置，如不使用，则不设置这个字段

        // 2. 连接海外机房特殊配置项，仅供设备数据上报海外机房客户使用
        // 2.1 业务机房在国内
        // 1) 用户分布：国内（默认设置）
        // apiHost:'fp-it.portal101.cn'
        // 2) 用户分布：全球
        // apiHost:'fp-it-acc.portal101.cn'

        // 2.2 业务机房在欧美（弗吉尼亚）
        // 1) 用户分布：欧美
        // apiHost: 'fp-na-it.portal101.cn'
        // 2) 用户分布：全球
        // apiHost: 'fp-na-it-acc.portal101.cn'

        // 2.3 业务机房在欧美（法兰克福）
        // apiHost: 'api-device-eur.portal101.cn'

        // 2.4 业务机房在东南亚
        // 1) 用户分布：东南亚
        // apiHost:'fp-sa-it.portal101.cn'
        // 2) 用户分布：全球
        // apiHost:'fp-sa-it-acc.portal101.cn'

        // 2.5 私有化特殊配置
        // staticHost: 'xxxxxx' // 私有化客户自己引入线上cdn地址，此项必填；如果客户本地引入js文件，此项不填
        // apiHost: 'xxxxxx';  // 私有化部署的服务域名
    };

    var url = (function() {
        var isHttps = document.location.protocol === 'https:';
        var protocol = isHttps ? 'https://' : 'http://';
        var fpJsPath = '/dist/web/v3.0.0/fp.min.js';
        var url = protocol + window._smConf.staticHost + fpJsPath;
        return url;
    })();
    var sm = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    sm.src = url;
    s.parentNode.insertBefore(sm, s);
}

/**
 * cb业务逻辑
 * 使用数美设备标识逻辑
 */
export function getSmDeviceId(cb) {
    var smDeviceId = '';
    var smDeviceIdReady = false;
    return new Promise((resolve) => {
        if (typeof window === 'undefined') {
            resolve('');
            cb && cb(smDeviceId);
            return;
        }
        window.SMSdk?.ready(async function() {
            if (window.SMSdk?.getDeviceId) {
                smDeviceId = await window.SMSdk.getDeviceId();
            }
            if (!smDeviceIdReady) {
                smDeviceIdReady = true;
                // 执行业务逻辑
                cb && cb(smDeviceId);
                resolve(smDeviceId);
            }
        });
    });
}
